/* ============================================
   CUSTOM JAVASCRIPT FOR cusuries.com THEME
   ============================================ */

/* ============================================
   VIDEO SECTION - Fullscreen Functionality
   ============================================ */

(function() {
  let overlay = null;
  let closeBtn = null;
  let escHandler = null;
  
  const addAutoplay = (url) => url + (url.includes('?') ? '&autoplay=1' : '?autoplay=1');
  
  const cleanup = () => {
    if (escHandler) {
      document.removeEventListener('keydown', escHandler);
      escHandler = null;
    }
    if (closeBtn) {
      closeBtn.remove();
      closeBtn = null;
    }
    if (overlay) {
      overlay.remove();
      overlay = null;
    }
  };
  
  const getVideoSource = (button) => {
    const customSrc = button.getAttribute('data-fullscreen-video-src');
    if (customSrc) return customSrc;
    
    const section = button.closest('.shopify-section--video');
    if (!section) return null;
    
    const videoMedia = section.querySelector('video-media');
    if (!videoMedia) return null;
    
    const video = videoMedia.querySelector('video') || videoMedia.querySelector('iframe');
    if (!video) return null;
    
    return video.tagName === 'VIDEO' ? (video.src || video.querySelector('source')?.src) : video.src;
  };
  
  const createVideoElement = (src) => {
    const isExternal = src.includes('youtube.com') || src.includes('vimeo.com');
    
    if (isExternal) {
      const iframe = document.createElement('iframe');
      iframe.className = 'video-page-fullscreen-overlay__iframe';
      iframe.src = addAutoplay(src);
      iframe.allow = 'autoplay; encrypted-media';
      iframe.allowFullscreen = true;
      return iframe;
    }
    
    const video = document.createElement('video');
    video.className = 'video-page-fullscreen-overlay__video';
    video.src = src;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    return video;
  };
  
  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-video-fullscreen]');
    if (!button) return;
    
    e.preventDefault();
    cleanup();
    
    const videoSrc = getVideoSource(button);
    if (!videoSrc) return;
    
    // Create overlay
    overlay = document.createElement('div');
    overlay.className = 'video-page-fullscreen-overlay active';
    
    const container = document.createElement('div');
    container.className = 'video-page-fullscreen-overlay__container';
    container.appendChild(createVideoElement(videoSrc));
    
    // Create close button
    closeBtn = document.createElement('button');
    closeBtn.className = 'video-page-fullscreen-overlay__close';
    closeBtn.type = 'button';
    closeBtn.innerHTML = '×';
    closeBtn.setAttribute('aria-label', 'Close fullscreen video');
    closeBtn.onclick = cleanup;
    
    // Add to DOM
    overlay.appendChild(container);
    document.body.appendChild(overlay);
    document.body.appendChild(closeBtn);
    
    // ESC key support
    escHandler = (e) => e.key === 'Escape' && cleanup();
    document.addEventListener('keydown', escHandler);
  });
})();

/* ============================================
   END: VIDEO SECTION
   ============================================ */

/* ============================================
   PRODUCT GALLERY - Side Arrows Initial State
   ============================================ */

/**
 * Set initial disabled state for product gallery side arrows
 * Ensures left arrow is disabled on first slide at page load
 */
(function() {
  const initArrowsState = () => {
    const galleries = document.querySelectorAll('.product-gallery--side-arrows');
    
    galleries.forEach(gallery => {
      const carousel = gallery.querySelector('media-carousel');
      const sideArrows = gallery.querySelector('.product-gallery__side-arrows');
      
      if (!carousel || !sideArrows) return;
      
      const prevButton = sideArrows.querySelector('[is="prev-button"]');
      const nextButton = sideArrows.querySelector('[is="next-button"]');
      
      if (!prevButton || !nextButton) return;
      
      // Get current index and total items
      const currentIndex = carousel.selectedIndex || 0;
      const totalItems = carousel.items.length;
      
      // Set initial disabled state
      if (currentIndex === 0) {
        prevButton.disabled = true;
      }
      if (currentIndex === totalItems - 1) {
        nextButton.disabled = true;
      }
    });
  };
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArrowsState);
  } else {
    // DOM already loaded
    initArrowsState();
  }
  
  // Support for theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initArrowsState);
  }
})();

/* ============================================
   END: PRODUCT GALLERY
   ============================================ */